<template>
  <div class="addcard">
    <Row type="flex" justify="center" class="code-row-bg">
      <Col :span="10">
        <Form ref="form" :model="form" :label-width="100">
          <FormItem label="持卡人姓名:">
            <span>{{`${this.form.customerName.slice(0,1)}**`}}</span>
          </FormItem>
          <FormItem label="选择总行" :rules="require1" prop="name">
            <Select v-model="form.name" placeholder="选择总行" style="width:585px;">
              <Option v-for="(item,i) in masterBank" :key='i' :value="item.name">{{item.name}}</Option>
            </Select>
          </FormItem>
          <FormItem label="支行" :rules="require1" prop="bankName">
            <Input v-model="form.bankName" :maxlength="50"></Input>
          </FormItem>
          <FormItem label="服务类型" :rules="require1" prop="bankType">
            <Select v-model="form.bankType" placeholder="选择服务类型" style="width:585px;">
              <Option value="对公">对公</Option>
              <Option value="对私">对私</Option>
            </Select>
          </FormItem>
          <FormItem label="银行卡卡号" :rules="require2" prop="cardNo">
            <Input  v-model="form.cardNo":maxlength="30"></Input>
          </FormItem>
          <FormItem label="确认卡号" prop="cardNo1" :rules="cardNo">
            <Input  v-model="form.cardNo1" :maxlength="30"></Input>
          </FormItem>
          <FormItem label="交易密码"  prop="cashPassword" :rules="require1">
            <Input v-model="form.cashPassword" :maxlength="6" type="password"></Input>
          </FormItem>
          <FormItem label="确认密码"  prop="newPassword" :rules="password">
            <Input v-model="form.newPassword" :maxlength="6" type="password"></Input>
          </FormItem>
          <FormItem>
            <my-button @confirm="handleSubmit('form')">保存</my-button>
            <my-button @confirm="()=>{this.$router.go(-1)}">取消</my-button>
          </FormItem>
        </Form>
        <div class="tip">
          <p>温馨提示：</p>
          <p>1、如果您填写的开户行支行不正确，可能将无法成功提现，由此产生的提现费用将不予返还。</p>
          <p>2、如果您不确定开户行支行名称，可打电话到所在地银行的营业网点询问或上网查询。</p>
          <p>3、不支持提现至信用卡账户。</p>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
  import ApiClient from '@/api/ApiClient'
  import MyButton from '@/components/MyButton'
  import passwordInput from '@/components/passwordInput'
  export default {
    components:{MyButton,passwordInput},
    data(){
      const validateCardNo = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please enter your cardNo again'));
        } else if (value !== this.form.cardNo) {
          callback(new Error('The two input cardNo do not match!'));
        } else {
          callback();
        }
      };
      const validatePassWord = (rule,value,callback)=>{
        if(value === ''){
          callback(new Error('Please enter your password again'));
        }if (value !== this.form.cashPassword) {
          callback(new Error('The two input password do not match!'));
        } else {
          callback();
        }
      };
      return {
        form:{
          bankName: "",
          bankType: "对公",
          cardNo: "",
          cashPassword: "",
          customerName: "",
          operChar: '0',
          customerId:'',
          newPassword:'',
          name:''
        },
        masterBank:[],
        modal2: false,
        value: '',
        require1:[{ required: true, message: '不能为空', trigger: 'blur'}],
        require2:[{ pattern: '^[0-9]*$',required: true, message: '输入不正确', trigger: 'blur',min:6}],
        cardNo:[{ validator: validateCardNo,required: true, message: '两次输入的卡号不一致', trigger: 'blur'}],
        password:[{validator:validatePassWord,required:true,message:'两次输入的密码不一致',trigger:'blur'}],
      }
    },
    methods:{
      handleSubmit(name){
        this.$refs[name].validate(valid => {
          if(valid){
            ApiClient.post('/desktop/profile/cardManage.do',this.form).then(data => {
              this.$router.go(-1)
            })
          }
        })
      },
    },
    mounted(){
      this.form.customerId=JSON.parse(sessionStorage.getItem('currentUser')).userId   //缓存中拿客户Id
      ApiClient.get('/desktop/profile/identification.do').then(data => {
        this.form.customerName = data.realName;
      })
      ApiClient.post('/commons/bankListQuery.do').then(data=>{
        this.masterBank = data.items
      })
    }
  }
</script>
<style lang="less">
  .addcard{
    .ivu-form-item-required .ivu-form-item-label:before {
      content: '';
      display: none;
    }
    .ivu-select{
      width:300px;
    }
    .tip{
      font-size: 15px;
      color: red;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/myProfile/addBankCard.vue